import { theme } from 'antd';
import { createTheme } from '@mui/material/styles';


export const customLightTheme = {
  algorithm: theme.defaultAlgorithm, // Light theme algorithm
  token: {
    colorBgBase: "#FFF",
    colorBgPrimary: "#FFF",
    colorBgLayout: '#eaeaea',   // For layout containers
    colorBorder: '#ededed',         // New: Default border color
    // For Button
    colorPrimary: '#1A1A1A', // Primary button background color
    colorError: '#A40F0F', // Update this
    colorTableRowHover: 'red',  // Light blue hover color (example)


    colorTextPrimary: '#FFFFFF', // Primary button text color
    borderRadius: '4px', // Button border radius to match Material Design

    // For Input
    inputBorderColor: '#3B69FA', // Input border color
    inputHoverBorderColor: '#3B69FA', // Input border color on hover
    inputFocusBorderColor: '#3B69FA', // Input border color on focus
    fontFamily: 'Inter, sans-serif',   // Your desired font family
    fontWeightStrong: 500,            // Heading weight (e.g., semibold)
    fontWeight: 400,                  // Default text weight (e.g., regular)
    colorTextHeading: '#1A1A1A',
    colorBgMask: 'rgba(255, 255, 255, 0.2)',
  },
  components: {
    Table: {
      stickyScrollBarBg: '#ededed',
      stickyScrollBarBorderRadius: '50%',
      rowHoverBg: '#D9F1F9',
      cellFontSize: 12,
      cellFontSizeMD: 11
    },
    Slider: {
      railBg: 'rgba(0, 0, 0, 0.4)',
      handleColor: '#00AFFF',
      dotBorderColor: 'red',
      dotActiveBorderColor: '#1a1a1a',
      handleColorDisabled: '#1a1a1a',
      handleActiveOutlineColor: '#1a1a1a',
      handleActiveColor: '#1a1a1a',
    },
    Input: {
      borderColor: "#1a1a1a"
    },
    Menu: {
      itemSelectedBg: '#091E420F',
      subMenuItemBg: 'transparent'
    },
        Segmented: {
      // Customize the Segmented component styles
      trackBg: '#FFF', // Set background color to white
          trackPadding: 0,
      borderColor: '#CCC', // Set border color to light gray
      itemHoverBg: '#0033ff', // Set selected segment background to light gray
          itemSelectedBg: '#1a1a1a',
          itemColor: "#1a1a1a",
          itemHoverColor: '#fff', // Set active segment text color to white
      itemSelectedColor: '#fff', // Set selected segment text color to black (adjust as needed)
    },

  },
};

export const customDarkTheme = {
  algorithm: theme.darkAlgorithm, // Dark theme algorithm
  token: {
    // Dark theme tokens
    // ...other dark theme tokens
  },
  components: {
    // ... (any component overrides for the dark theme)
  }
};


export const customLightMuiTheme = createTheme({
  palette: {
    primary: {
      main: '#1a1a1a',  // Ant Design's colorPrimary (black)
    },
    secondary: {
      main: 'rgb(13, 42, 76, 0.6)',    // Ant Design's colorTextSecondary (dark gray)
    },
    success: {
      main: '#1a1a1a', // Custom success color
    },
    error: {
        main: '#F5222D', // Ant Design's colorError (red)
    },
    warning: {
        main: '#BF5700', // U.T. Texas orange
    },
    background: {
      default: '#FFF',  // Ant Design's colorBgBase (white)
      paper: '#FFF',    // Ant Design's colorBgLayout (white)
    },
    text: {
      primary: '#FFF', // Ant Design's colorTextPrimary (white)
    }
  },
    text: {
      primary: 'red', // Use Ant Design variable for primary text
      secondary: 'var(--ant-text-color-secondary)',
      disabled: 'var(--ant-disabled-color)', // Customize disabled text color
    },
  typography: {
    fontFamily: 'Inter, sans-serif', // Match Ant Design font
    h1: {
      color: '#1A1E23'   // Match Ant Design's colorTextHeading (black)
    },
    // ... other typography overrides if needed
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ownerState})=>( {
          borderRadius: '4px', // Match Ant Design's borderRadius

          ...(ownerState.color === 'info' && ownerState.variant === 'contained' && {
                    border: 'none',
                    background: '#0B67F6',
          }),
        }),
      },
    },
    MuiInputBase: { // Style the Input component
      styleOverrides: {
        root: ({ ownerState }) => ( {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3B69FA', // Match Ant Design's inputBorderColor
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3B69FA', // Match Ant Design's inputHoverBorderColor
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3B69FA', // Match Ant Design's inputFocusBorderColor
          },
          ...(ownerState.size === 'small' && {
            padding: '1px', // 1px padding on all sides
            '& .MuiInputBase-input': {
              fontSize: '0.75rem', // Smaller font size (adjust as needed)
            },
          }),
        }),
        input: { // Style the actual input element
          color: '#1a1a1a', // Set the default text color to black
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(0, 0, 0, 0.03)', // Adjust as needed to match Ant Design
        },
        stickyHeader: { // style sticky header
          backgroundColor: 'rgba(0, 0, 0, 0.03)'
        }
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: '50%' // match table scroll bar
        }
      }
    },
    MuiChip: {
        styleOverrides: {
            root: ({ ownerState }) => ({
                ...(ownerState.color === 'secondary' && ownerState.variant === 'outlined' && {
                    border: 'none',
                    background: 'linear-gradient(to right, #ff6e7f, #bfe9ff)',
                }),
              ...{
              },
                ...(ownerState.color === 'primary' && ownerState.variant==='filled' && {
                    padding: '16px 12px',
                    borderRadius: 6, // Add rounded corners if desired
                    background: 'linear-gradient(to right, #161823, #0C0D14)',

                }),
            }),
        },
    },
  },
});


